import bgImg from '@/assets/images/img_2.webp'
import Menu from '@/components/Menu'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { Outlet } from 'react-router-dom'
import GlobalDeviceChange from '../GlobalDeviceChange'

const Container = styled(motion.div)`
  /* background-image: url('${bgImg}'); */
  background-color: #f5f5f5;
`
const Center = styled(motion.div)``
const Left = styled(motion.div)``
const Right = styled(motion.div)`
  /* box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  padding: 20px;
  background-color: #fff;
  border-radius: 6px; */
`

export default () => {
  return (
    <Container className="w-screen">
      <Center className="w-[1200px] ml-auto mr-auto pt-[20px] pb-[20px] flex">
        <Left>
          <Menu />
        </Left>
        <Right className="flex-1 ml-[20px] ">
          <Outlet />
        </Right>
      </Center>
      <GlobalDeviceChange />
    </Container>
  )
}
